import { render } from "./side-panel.vue?vue&type=template&id=5486e2d6&scoped=true"
import script from "./side-panel.vue?vue&type=script&lang=js"
export * from "./side-panel.vue?vue&type=script&lang=js"

import "./side-panel.vue?vue&type=style&index=0&id=5486e2d6&lang=stylus&scoped=true"

import exportComponent from "/var/www/docker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5486e2d6"],['__file',"src/components/admin-dashboard/panels/side-panel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5486e2d6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5486e2d6', __exports__)) {
    api.reload('5486e2d6', __exports__)
  }
  
  module.hot.accept("./side-panel.vue?vue&type=template&id=5486e2d6&scoped=true", () => {
    api.rerender('5486e2d6', render)
  })

}


export default __exports__